<template>
  <div class="form-field" :class="formFieldClass">
    <label v-if="label" :for="id">{{ label }}</label>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    required: true,
  },
  direction: {
    type: String,
    default: 'left',
  },
});

const formFieldClass = computed(() => {
  const direction =
    props.direction === 'left' ? 'direction-left' : 'direction-top';
  return [direction];
});
</script>

<style scoped lang="scss">
.form-field {
  @apply flex gap-8;
  &.direction-top {
    @apply flex flex-col;
  }
}

@media (min-width: 320px) and (max-width: 1279px) {
  .form-field {
    width: 100%;
  }
}
</style>
